import PhotoEditorModal from 'components/PhotoEditorModal'
import { POST } from "api/request"
import { useState } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface AddMainPhotoModalProps {
  body: board.Board | undefined
  onClose: () => void
  onReload: () => void
}

const AddMainPhotoModal: React.FC<AddMainPhotoModalProps> = ({ body, onClose, onReload }) => {
  const [isModal, setModal] = useState(false)
  const [isSending, setSending] = useState<boolean>(false)
  const [isInfoVisible, setInfoVisible] = useState<boolean>(false)
  const [selectedImage, setSelectedImage] = useState<File | null>(null)

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0]
      setSelectedImage(file)
    }
    setModal(true)
  }

  const handleClose = () => {
    window.history.back() 
    onReload()
    onClose()
  }

  const handleSubmit = async () => {
    if (selectedImage === null) return
    setSending(true)
    const formData = new FormData()

    if (selectedImage) {
      formData.append('img', selectedImage)
    }

    try {
      const response = await POST(url.updatedBoard(body?.id), {
        form: formData,
      })
      if (response.ok) {
        setInfoVisible(true)
      } else {
        alert('W trakcie wysyłania wystąpił błąd')
      }
    } catch (err) {
      console.error(err)
    } finally {
      setSending(false)
    }
  }

  const showPrevieCondition = () => {
    if (!selectedImage) {
      if (body?.img) {
        return body.img
      } else return ''
    } else {
      return URL.createObjectURL(selectedImage)
    }
  }

  return (
    <>
      {isModal && (selectedImage || body?.img)
        ? <PhotoEditorModal
          photo={selectedImage || {
            name: 'rabarbar',
            type: 'image/jpeg',
            stringSrc: body!.img
          }}
          setPhoto={setSelectedImage}
          close={() => {
            setModal(false)
          }}
        />
        : <Modal
          icon='add-photo'
          onClose={onClose}
          title={isInfoVisible ? 'Wysłano' : 'Dodaj główne zdjęcie'}
          primaryDisabled={isSending}
          primaryButton={isInfoVisible ? '' : isSending ? "Wysyłanie..." : 'Wyślij'} primaryButtonAction={handleSubmit}
          secondaryButton={isInfoVisible ? 'Zamknij' : 'Anuluj'} secondaryButtonAction={isInfoVisible ? handleClose : 'close'}>

          <div className="modal__addPost">

            {isInfoVisible
              ? <div className="info">
                <p>Dodano główne zdjęcie</p>
              </div>
              : <>
                <div className="myInput">
                  <label>Ustal zdjęcie główne</label>
                  <div className='drop' onClick={() => document.getElementById('fileInput')?.click()}>
                    {!selectedImage && !body?.img &&
                      <>
                        <i className='icon icon--add-photo s32'></i>
                        <span>Dodaj zdjęcie</span>
                      </>}
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: 'none' }}
                      onChange={handleImageChange}
                      accept="image/*"
                    />
                    {selectedImage || body?.img ? (<>
                      <div className='imgWrap'>
                        <img src={showPrevieCondition()} alt="Podgląd miniaturki" style={{ width: '100%', height: '50vh', objectFit: 'cover' }} />
                      </div>
                    </>
                    )
                      : undefined}
                  </div>
                  {selectedImage || body?.img
                    ? <div className="dropButtons">
                      <button
                        className='btn btn--round'
                        onClick={() => document.getElementById('fileInput')?.click()}>
                        <i className='icon icon--settings'></i>
                        Zmień zdjęcie
                      </button>

                      <button
                        className='btn btn--round'
                        style={{ flexGrow: '1' }}
                        onClick={e => {
                          e.stopPropagation()
                          setModal(true)
                        }}>
                        <i className='icon icon--settings'></i>
                        Edytuj
                      </button>
                    </div>
                    : undefined}
                </div>
              </>}
          </div>
        </Modal >}
    </>)
}

export default AddMainPhotoModal
